import script from "./CameraView.vue?vue&type=script&setup=true&lang=js"
export * from "./CameraView.vue?vue&type=script&setup=true&lang=js"

import "./CameraView.vue?vue&type=style&index=0&id=acaea39a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-acaea39a"]])

export default __exports__